import { Autocomplete, TextField } from "@mui/material";

export default function SelectSysOutline({ options, title, color = '', ...props }) {
  return (
    <Autocomplete
      options={options}
      limitTags={1}
      id="select-sys"
      size="small"
      renderInput={(params) => <TextField {...params}  label={title} variant='outlined'  color={color} />}
      renderOption={(props, option) => {
        return (
          <li {...props} style={{textTransform: "capitalize"}} key={option.id}>
            {option.label}
          </li>
        );
      }}
      {...props}
    />
  );
}
